import { Chip } from '@/components/ui'
import { STATE_META } from '../utils/state-meta'

export function StateBadge({ state }: { state: string }) {
  const meta = STATE_META[state] ?? { label: state, variant: 'neutral' as const }
  return (
    <Chip size="xs" variant={meta.variant} dot>
      {meta.label}
    </Chip>
  )
}
